import { ReactComponent as ArrowIcon } from "assets/icons/arrow.svg";
import Link from "components/Link";
import { Text } from "iparque-components";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Column } from "../styles";
import { getAddresses } from "./addresses";
import {
  AddressesRow,
  ArrowContainer,
  CenterContainer,
  Container,
} from "./styles";

const WhereAreWe: React.FC = () => {
  const { t } = useTranslation();
  const [isAddressOpen, setIsAddressOpen] = useState(false);

  const toggleAddress = () => setIsAddressOpen(!isAddressOpen);

  const renderAddresses = () =>
    getAddresses(t).map((address) => (
      <Column key={address.district} className="company-address">
        <Text variant="body6" className="mb-10" color="quaternary">
          {address.district}
        </Text>
        {address.addressComponents.map((addressComponent) => (
          <Text key={addressComponent[0]} variant="body7" color="quaternary">
            {addressComponent}
          </Text>
        ))}
        <Text variant="body7" className="mt-20" color="quaternary">
          <Link href={address.mapUrl}>{t("7133") /* Ver no mapa */}</Link>
        </Text>
      </Column>
    ));

  return (
    <Container>
      <CenterContainer>
        <Text variant="body6" color="tertiary">
          {t("7817") /* Onde Estamos */}
        </Text>
        <ArrowContainer isAddressOpen={isAddressOpen} onClick={toggleAddress}>
          <ArrowIcon />
        </ArrowContainer>
      </CenterContainer>
      <AddressesRow isAddressOpen={isAddressOpen}>
        {renderAddresses()}
      </AddressesRow>
    </Container>
  );
};

export default WhereAreWe;
